export default "__VITE_ASSET__74be66b4__"